module.exports = __webpack_public_path__ + "static/media/youtube.a15f79b0.svg";